export type StatusFilter = "all" | "active" | "paused";

/** Mirror-only rows (entities with no stats row in the range — a paused ad
 *  group almost never has traffic) are appended on the client, so they must
 *  pass the SAME test the server applies to stats rows: `status = 'ENABLED'`
 *  for "active", `status = 'PAUSED'` for "paused". Equality on purpose — a
 *  row with no status yet is not "active", exactly as on the server. */
export function adGroupPassesStatusFilter(
  status: string | null | undefined,
  filter: StatusFilter,
): boolean {
  if (filter === "all") return true;
  return status === (filter === "active" ? "ENABLED" : "PAUSED");
}
